<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    class="icon-svg icon-linkedin"
  >
    <title>Linkedin logo</title>
    <g
      fill-rule="evenodd"
    >
      <path
        d="M6.28 1.454c-2.66 0-4.825 2.166-4.825 4.827V25.72c0 2.661 2.165 4.826 4.826 4.826H25.72c2.66 0 4.826-2.165 4.826-4.826V6.281c0-2.66-2.165-4.827-4.826-4.827H6.28zM25.72 32H6.28C2.819 32 0 29.183 0 25.72V6.28C0 2.817 2.818.001 6.28.001h19.44C29.183 0 32 2.816 32 6.28V25.72C32 29.183 29.183 32 25.72 32z"
      />
      <path
        d="M15.096 22.658V13.74c0-.235.213-.47.469-.47h.342c.182 0 .3.063.36.216l.236.83.104-.094c.899-.75 2.032-1.161 3.203-1.165 2.859 0 3.563 1.856 3.563 4.394v5.206c-.01.255-.214.46-.47.469h-.64c-.258-.002-.467-.211-.47-.47V17.24c0-1.878-.638-2.753-2.09-2.753-1.855 0-3.03 1.366-3.03 1.366v6.805c-.01.255-.213.46-.468.469h-.64c-.258-.002-.467-.211-.47-.47zm-4.907 0c0 .256.213.469.469.469h.64c.235 0 .469-.213.469-.47v-8.916c0-.235-.234-.47-.47-.47h-.64c-.254.01-.458.215-.468.47v8.917zm.746-11.925c.662 0 1.174-.533 1.174-1.152 0-.683-.512-1.195-1.174-1.195-.64 0-1.151.512-1.151 1.195 0 .619.512 1.152 1.15 1.152z"
      />
    </g>
  </svg>
</template>
